module.exports = __webpack_public_path__ + "img/zdd_invite_jx_1.a8d78608.png";